module.exports = __webpack_public_path__ + "static/media/ErrorIcon.aadd34b7.svg";